import { render, staticRenderFns } from "./PrintStudio.vue?vue&type=template&id=fa29b138&scoped=true&"
import script from "./PrintStudio.vue?vue&type=script&lang=js&"
export * from "./PrintStudio.vue?vue&type=script&lang=js&"
import style0 from "./PrintStudio.vue?vue&type=style&index=0&id=fa29b138&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa29b138",
  null
  
)

export default component.exports